"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BACKSPACE = exports.DOWN = exports.RIGHT = exports.UP = exports.LEFT = exports.K = exports.ESCAPE = exports.ENTER = void 0;
var ENTER = 13;
exports.ENTER = ENTER;
var ESCAPE = 27;
exports.ESCAPE = ESCAPE;
var K = 75;
exports.K = K;
var LEFT = 37;
exports.LEFT = LEFT;
var UP = 38;
exports.UP = UP;
var RIGHT = 39;
exports.RIGHT = RIGHT;
var DOWN = 40;
exports.DOWN = DOWN;
var BACKSPACE = 8;
exports.BACKSPACE = BACKSPACE;